<template>
  <section>
    <b-row class="mb-2 mr-1">
    </b-row>
    <b-alert variant="secondary" show>
      <b-row cols="12" class="mb-1 alert-heading">
        <b-col class="d-flex align-items-center justify-content-between">
          <b-form-checkbox checked="true" @change="hideShowFilter"
            ><b>show filters</b></b-form-checkbox
          >
          <b-input-group style="width: 400px" class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon" />
            </b-input-group-prepend>
            <b-form-input
              placeholder="Search"
              v-model="filters.search"
              @input="onSearch"
            />
          </b-input-group>
          <b-button-group>
              <b-button
                block
                size="m"
                class="w-100"
                variant="gradient-success"
                @click="downloadSubLicenseContractsCSV"
              >
                <span class="text-nowrap"> Export </span>
              </b-button>
          </b-button-group>
        </b-col>
      </b-row>
    </b-alert>

    <b-row v-if="this.filtersHidden == false">
      <b-col sm="12" md="4" lg="4">
        <v-select
          class="mb-1"
          v-model="filters.movie"
          :options="$store.state.master.movies"
          :filter-by="movieFilter"
          label="name"
          :reduce="(movie) => movie.id"
          placeholder="Movie"
          @input="onFiltersChange"
          @search="onSearchMovie"
        />
      </b-col>
      <b-col sm="12" md="3" lg="3">
        <v-select
          class="mb-1"
          v-model="filters.vendor"
          :options="$store.state.master.vendors"
          label="company"
          :reduce="(vendor) => vendor.vendor_id"
          placeholder="Customer"
          @input="onFiltersChange"
          @search="onSearchCustomer"
        />
      </b-col>
      <b-col sm="12" md="2" lg="2">
        <flat-pickr
          :config="{
            ...$flatPickrConfig,
          }"
          placeholder="Start Date"
          class="form-control mb-1"
          v-model="filters.from_cl"
          @input="onFiltersChange"
        />
      </b-col>
      <b-col sm="12" md="2" lg="2">
        <flat-pickr
          :config="{
            ...$flatPickrConfig,
          }"
          placeholder="To Date"
          class="form-control mb-1"
          v-model="filters.to_cl"
          @input="onFiltersChange"
        />
      </b-col>
      <b-col sm="6" md="1" lg="1">
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          class="w-100 mb-1"
          @click="clearFilters"
          >Reset</b-button
        >
      </b-col>
    </b-row>

    <!-- Contracts List Table -->
    <b-card no-body v-if="$can('read', 'contract')">
      <b-table
        small
        bordered
        class="position-relative"
        primary-key="contract_id"
        responsive
        :empty-text="tableEmptyText"
        show-empty
        :items="contractsList"
        :fields="fields"
        hover
        @row-clicked="openRowModal"
      >
        <!-- hover -->
        <template #head(sr)="data">
          <b-badge v-if="pagination.totalRows" variant="success">{{
            pagination.totalRows
          }}</b-badge>
        </template>
        <template #cell(sr)="data">
          {{ data.index + 1 + (pagination.currentPage - 1) * pagination.limit }}
        </template>
        <template #cell(company)="data">
          <div style="width: max-content">
            <b-badge variant="light-primary"
              >{{ `#C${data.item.contract_nature[0]}${data.item.contract_id}` }}
            </b-badge>
            <br />
            <b-badge variant="light-primary">
              {{ data.item.contract_nature
              }}{{ data.item.draft ? "(draft)" : "" }}</b-badge
            ><br />{{ data.item.company }}
          </div>
        </template>
        <template #cell(title)="data">
            <div v-html="data.value"></div>
        </template>
        <template #cell(statementPeriod)="data">
            <div style="display: flex; align-items: center; flex-direction: column;">
                 <template v-for="(statement, index) in data.item.statements">
                    <span>{{getPeriod(statement.period)}}</span>
                 </template>
            </div>
        </template>
        <template #cell(nextStatementDue)="data">
          <div style="display: flex; align-items: center; flex-direction: column;">
            <template v-for="(statement, index) in data.item.statements">
              <div class="mb-1">
                <flat-pickr
                  :value="getNextDate(statement.period)"
                  :config="{
                    ...$flatPickrConfig,
                    dateFormat: 'd-m-Y',
                    defaultDate: getNextDate(statement.period),
                    allowInput: true
                  }"
                  class="form-control"
                  @change="(date) => handleDateChange(data.item.contract_id, statement, date)"
                />
              </div>
            </template>
          </div>
        </template>
        <template #cell(purchaseDate)="data">
          <b-badge variant="light-info"
            >Contract Date : {{ data.item.purchaseDate }} </b-badge
          ><br />
          <b-badge variant="light-success" class="mt-1">
            Start : {{ data.item.rStart }} </b-badge
          ><br />
          <b-badge variant="light-danger" class="mt-1">
            End : {{ data.item.rExpiry }}</b-badge
          >
        </template>
        <template #cell(lastStatementUploaded)="data">
          <div class="mb-1">
            <span>Last Statement received: </span>
            <b-badge variant="secondary" v-if="data.item.lastStatementReceivedDate"> {{formatDate(data.item.lastStatementReceivedDate)}} </b-badge>
          </div>
          <div>
            <span>Net Amount added to Acquisition Report: </span>
            <span>{{ data.item.lastStatementDue }}</span>
          </div>
          <!-- <div class="mt-1">
            <span>Files: </span>
            <div
              v-for="(file, file_index) in data.item.upload"
              :key="'images-' + file_index"
              class="pr-1"
              style="width:18rem ;overflow-wrap: break-word;"
            >
              <a class="mt-1" @click.stop="openFile(file)" v-if="checkIfImage(file)">
                {{ file_index + 1 }}-<u>{{
                  file && file[0]
                    ? file[0]
                    : file
                    ? getImgSrc(file).split("/").slice(-1).toString()
                    : ""
                }}</u>
                <b-img
                  :src="getImgSrc(file)"
                  v-bind="imgProps"
                  rounded="circle"
                  class="ml-1"
                  alt="Circle image"
                ></b-img>
              </a>
              <a class="mt-1" @click.stop="openFile(file)" v-else>
                {{ file_index + 1 }}-<u>{{
                  file && file[0]
                    ? file[0]
                    : file
                    ? getImgSrc(file).split("/").slice(-1).toString()
                    : ""
                }}</u>
                <b-img
                  :src="filesDefaultImg"
                  v-bind="imgProps"
                  rounded="circle"
                  class="ml-1"
                  alt="Circle image"
                ></b-img>
              </a>
            </div>
          </div> -->
        </template>
        <template #cell(additionalContractData)="data">
          <div
            style="display: flex; justify-content: center; align-items: center"
          >
            <feather-icon
              style="cursor: pointer"
              icon="InfoIcon"
              size="23"
              @mouseenter="handleContractHoveredSet(data.item.contract_id)"
              @mouseleave="handleContractReleased()"
            />
          </div>
          <div v-if="hoveredContractId === data.item.contract_id">
            <hover-metadata-component
              :item="data.item"
              :idField="'contract_id'"
              :createdAt="data.item.createdAt"
              :createdBy="data.item.createdBy_user"
              :updatedAt="data.item.updatedAt"
              :updatedBy="data.item.updatedBy_user"
              :isHovered="hoveredContractId === data.item.contract_id"
              :showAbove="data.index >= itemsInRow - 3? true : false "
            />
          </div>
        </template>
      </b-table>

      <template #footer>
        <div>
          <b-row>
            <b-col
              class="d-flex align-items-end justify-content-end justify-content-sm-center"
            >
              <b-pagination
                v-model="pagination.currentPage"
                :total-rows="pagination.totalRows"
                :per-page="pagination.limit"
                @change="onChange"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
                :limit="15"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </template>
      <b-modal
        v-model="showModal"
        ref="detailedView"
        :title="`#C${modalItem.contract_nature ? modalItem.contract_nature[0] : ''}${modalItem.contract_id} - ${modalItem.company} , ${modalItem.title}`"
        size="lg"
        centered
        hide-footer
      >
        <b-row>
          <b-col class="mb-2" cols="12" md="4" lg="4">
            <h5>Net Amount added to Acquisition Report</h5>
            <div>
             <b-form-radio-group
                :id="`radio-group-${modalItem.contract_id}`"
                v-model="modalData.amountAdded"
                :name="`radio-group-${modalItem.contract_id}`"
                style="display: flex; flex-direction: column;"
              >
                <b-form-radio
                  :id="`radio-yes-${modalItem.contract_id}`"
                  :name="`radio-yes-${modalItem.contract_id}`"
                  value="Yes"
                  >Yes</b-form-radio
                >
                <b-form-radio
                  :id="`radio-no-${modalItem.contract_id}`"
                  :name="`radio-no-${modalItem.contract_id}`"
                  value="No"
                  >No</b-form-radio
                >
              </b-form-radio-group>
           </div>
          </b-col>
          <b-col class="mb-2" cols="12" md="4" lg="4">
            <h5>Last Statement received per</h5>
            <flat-pickr
              @input="(date) => changeModalDueDate(date)"
              v-model="modalData.date"
              placeholder="Select Date"
              class="form-control"
              :config="{ ...$flatPickrConfig }"
            /> 
          </b-col>
          <b-col class="mb-2" cols="12" md="4" lg="12">
            <h5>File</h5>
            <files-container
                v-model="modalData.upload"
                :showUploadDate="false"
                @remove="uploadModalFile($event)"
                @input="uploadModalFile($event)"
              />
          </b-col>

          <b-col class="mb-2" cols="12" md="4" lg="12">
            <h5>Current Files: </h5>
            <div
              v-for="(file, file_index) in modalItem.upload"
              :key="'images-' + file_index"
              class="pr-1"
              style="width:18rem ;overflow-wrap: break-word;"
            >
              <a class="mt-1" @click.stop="openFile(file)" v-if="checkIfImage(file)">
                {{ file_index + 1 }}-<u>{{
                  file && file[0]
                    ? file[0]
                    : file
                    ? getImgSrc(file).split("/").slice(-1).toString()
                    : ""
                }}</u>
                <b-img
                  :src="getImgSrc(file)"
                  v-bind="imgProps"
                  rounded="circle"
                  class="ml-1"
                  alt="Circle image"
                ></b-img>
              </a>
              <a class="mt-1" @click.stop="openFile(file)" v-else>
                {{ file_index + 1 }}-<u>{{
                  file && file[0]
                    ? file[0]
                    : file
                    ? getImgSrc(file).split("/").slice(-1).toString()
                    : ""
                }}</u>
                <b-img
                  :src="filesDefaultImg"
                  v-bind="imgProps"
                  rounded="circle"
                  class="ml-1"
                  alt="Circle image"
                ></b-img>
              </a>
            </div>
          </b-col>

          <b-col class="mb-2" cols="12" md="4" lg="12">
            <h5>History:</h5>
            <div class="history-box"
            v-if="modalItem.history && modalItem.history.length > 0 && modalItem.history[0].date"
            >
              <div
              v-for="(item, index) in modalItem.history"
              v-if="modalItem.history[0].date"
              :key="'history-row-'+ index"
              class="history-item-row"
              >
                <div class="history-index">{{ index + 1 }} - </div>
                <div class="history-content">
                  <span class="mr-2">{{ formatDate(item.date) }} -</span>
                  <span class="mr-2">{{ item.amountAdded }} -</span>
                  <span class="mr-2">Files: </span>
                  <span
                    v-for="(file, file_index) in item.upload"
                    :key="'images-' + file_index"
                    class="pr-1 d-inline-block"
                  >
                    <a class="mt-1" @click.stop="openFile(file)" v-if="checkIfImage(file)">
                      {{ file_index + 1 }}-<u>{{
                        file && file[0]
                          ? file[0]
                          : file
                          ? getImgSrc(file).split("/").slice(-1).toString()
                          : ""
                      }}</u>
                      <b-img
                        :src="getImgSrc(file)"
                        v-bind="imgProps"
                        rounded="circle"
                        class="ml-1"
                        alt="Circle image"
                      ></b-img>
                    </a>
                    <a class="mt-1" @click.stop="openFile(file)" v-else>
                      {{ file_index + 1 }}-<u>{{
                        file && file[0]
                          ? file[0]
                          : file
                          ? getImgSrc(file).split("/").slice(-1).toString()
                          : ""
                      }}</u>
                      <b-img
                        :src="filesDefaultImg"
                        v-bind="imgProps"
                        rounded="circle"
                        class="ml-1"
                        alt="Circle image"
                      ></b-img>
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </b-col>
          <b-col class="mb-2" cols="12" md="4" lg="12">
            <b-button
              block
              size="m"
              class="w-100"
              variant="gradient-success"
              :disabled="!modalData.date"
              @click="saveModalData(modalItem.contract_id)"
            >
              <span class="text-nowrap"> Save </span>
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
    </b-card>
  </section>
</template>

<script>
import {
  BCard,
  BBadge,
  BTable,
  BCol,
  BRow,
  BButton,
  BInputGroupPrepend,
  BInputGroup,
  BFormInput,
  BPagination,
  BDropdown,
  BDropdownItem,
  BTooltip,
  BModal,
  VBTooltip,
  BFormCheckbox,
  BButtonGroup,
  BAlert,
  BDropdownDivider,
  BDropdownForm,
  BFormRadioGroup,
  BFormRadio,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import * as XLSX from "xlsx";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import * as ContractServices from "@/apiServices/ContractServices";
import { labels, statement_period } from "@/utils/constants";
import Treeselect from "@riophae/vue-treeselect";
import ToastificationContentVue from "@/@core/components/toastification/ToastificationContent.vue";
import { TokenService } from "@/apiServices/storageService";
import { downloadFromURL } from "@/utils/helpers";
import UploadSheets from "@/views/components/UploadSheets.vue";
import FilesContainer from "@/views/components/FilesUpload/FilesContainer.vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import HoverMetadataComponent from "@/views/components/HoverMetadataComponent.vue";
import moment from "moment";

export default {
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  components: {
    BCard,
    BBadge,
    BTable,
    BCol,
    BRow,
    BButton,
    BInputGroupPrepend,
    BInputGroup,
    BFormInput,
    BPagination,
    FeatherIcon,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BTooltip,
    BModal,
    vSelect,
    Treeselect,
    flatPickr,
    BButtonGroup,
    UploadSheets,
    FilesContainer,
    AppCollapseItem,
    AppCollapse,
    BAlert,
    BDropdownDivider,
    BDropdownForm,
    HoverMetadataComponent,
    XLSX,
    BFormRadioGroup,
    BFormRadio,
  },
  data() {
    return {
      hoveredContractId: null,
      iconHovered: false,
      showModalUpload1: false,
      showModalUpload2: false,
      showModalUpload3: false,
      tableEmptyText: "LOADING...",
      filters: {
        search: "",
        contract_nature: "Sales",
        vendor: "",
        movie: "",
        from_cl: "",
        to_cl: "",
      },

      pagination: {
        currentPage: 1,
        limit: 10,
        totalRows: 0,
        perPageOptions: [10, 25, 50, 100, "All"],
      },
      fields: [
        {
          key: "sr",
          label: "SR",
          // sortable:true,
        },
        {
          key: "company",
          label: "Contact",
        },
        {
          key: "title",
          label: "Movie",
        },
        {
          key: "purchaseDate",
          label: "contract dates",
        },
        {
          key: "statementPeriod",
          label: "Statement Period",
        },
        {
          key: "nextStatementDue",
          label: "Next Statement Due Per" ,
        },
        {
          key: "lastStatementUploaded",
          label: "Last Statement Uploaded"
        },
        {
          key: "additionalContractData",
          label: "LOGS",
        },
      ],
      contractsList: [],
      selectedContractId: null,
      filtersHidden: false,
      searchMovieTerm: "",
      searchCustomerTerm: "",
      uploadedFilesPrev: [],
      itemsInRow: 10,
      modalItem: {},
      modalData: {
        amountAdded: "",
        date: "",
        upload: [],
      },
      showModal: false,
      imgProps: {
        blank: false,
        blankColor: "#777",
        width: 25,
        height: 25,
        class: "m1",
      },
      filesDefaultImg: require("@/assets/images/pages/files-documents.png"),
    };
  },
  computed: {
    files_url() {
      return process.env.VUE_APP_FILESURL+ "/";
    },
  },
  methods: {
    handleContractHoveredSet(contract_id) {
      // console.log("contract_id", contract_id);
      this.hoveredContractId = contract_id;
    },
    handleContractReleased(contract_id) {
      // console.log("contract_id", contract_id);
      this.hoveredContractId = null;
    },
    hideShowFilter() {
      this.filtersHidden = !this.filtersHidden;
    },
    uploadContractsExcel() {
      try {
      } catch (error) {
        console.error(`Error in uploadContractsExcel `, error);
      }
    },
    downloadSubLicenseContractsCSV() {
      try {
        const token = TokenService.getToken();

        if (!token) {
          alert("Error in getting token");
        }

        let urlStr = `${process.env.VUE_APP_BASEURL}/contract/sheet/sublicense/download?authorization=${token}`;

        downloadFromURL(urlStr, "SubLicense", "csv");
      } catch (error) {
        console.error(`Error in downloadSubLicenseContractsCSV `, error);
      }
    },
    movieFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return (
        option.name && option.name.toString().toLowerCase().indexOf(temp) > -1
      );
    },
    clearFilters() {
      this.filters = {
        search: "",
        contract_nature: "",
        vendor: "",
        movie: "",
        territories: [],
        rights: [],
        languages: [],
        from_cl: "",
        to_cl: "",
      };
      this.pagination = {
        ...this.pagination,
        currentPage: 1,
        limit: 10,
        totalRows: 0,
      };
      this.onChange();
    },
    onFiltersChange() {
      this.pagination.currentPage = 1;
      this.onChange();
    },
    async changeLastStatementDueDate(contract_id, value){
      try {
        const payload = {
          contract_id: contract_id,
          lastStatementDueDate: value,
        };
        const response = await ContractServices.saveLastStatementDueDate(payload);

      } catch(error) {
        console.error("Error saving last statement due:", error);
      }
    },
    changeModalDueDate(value) {
      this.modalData = {
        ...this.modalData,
        date: value
      };
    },
    // getLastStatementDate(date, data) {
    //   changeLastStatementDueDate(data.item.contract_id, date)
    // },
    async updateStatementDueDate(contract_id, statement, newDate) {
      try {
        if (!newDate || !moment(newDate).isValid()) {
          throw new Error("Invalid date");
        }
        const payload = {
          contract_id: contract_id,
          period: statement.period, 
          next_due_date: newDate 
        };
        // const response = await ContractServices.updateStatementDueDate(payload);
        this.$toast({
          component: ToastificationContentVue,
          props: {
            title: 'Success',
            text: 'Due date updated successfully',
            variant: 'success',
          },
        });
        this.getContractsList();
      } catch (error) {
        console.error("Error updating due date:", error);
        this.$toast({
          component: ToastificationContentVue,
          props: {
            title: 'Error',
            text: error.message || 'Failed to update due date',
            variant: 'danger',
          },
        });
      }
    },
  
    onSearch() {
      if (this.debouce) clearTimeout(this.debouce);
      this.debouce = setTimeout(() => {
        this.onFiltersChange();
      }, 1000);
    },
    openRowModal(item, index, event) {
      this.modalItem = this.contractsList[index];
      if (this.modalItem.history && typeof this.modalItem.history === 'string') {
        try {
          // Parse the JSON string into a JavaScript array
          this.modalItem.history = JSON.parse(this.modalItem.history);
        } catch (e) {
          console.error("Failed to parse history JSON:", e);
          // Fallback to an empty array on error
          this.modalItem.history = [];
        }
      } else if (!this.modalItem.history) {
        this.modalItem.history = [];
      }
      this.showModal = true;
    },
    async getContractsList() {
      const loader = this.$loading.show();

      try {
        const response = await ContractServices.getSubLicenseList({
          limit: this.pagination.limit,
          page: this.pagination.currentPage,
          ...this.filters,
        });

        const contracts = response.data.data.contracts;
        this.contractsList = contracts.map(contract => {
          this.$set(contract, 'lastStatementDue', contract.lastStatementDue || "No");
          return contract;
        });
        this.itemsInRow = this.contractsList.length;
        if (!isNaN(response.data.data.totalRows)) {
          this.pagination.totalRows = response.data.data.totalRows;
        }
        if (!this.contractsList.length)
          this.tableEmptyText = "NO RECORDS FOUND";
      } catch (error) {
        console.log("Error in getting Contracts List");
        this.tableEmptyText = "Error in getting contracts for sub license list";
      } finally {
        loader.hide();
      }
    },
    onChange() {
      this.$nextTick(() => {
        this.getContractsList();
        localStorage.setItem(
          "filtersAndPaginationSubLicense",
          JSON.stringify({
            filters: this.filters,
            pagination: this.pagination,
          })
        );
      });
    },
    loadContractList() {
      const filtersAndPaginationSubLicenseStr = localStorage.getItem(
        "filtersAndPaginationSubLicense"
      );
      if (filtersAndPaginationSubLicenseStr) {
        const obj = JSON.parse(filtersAndPaginationSubLicenseStr);
        this.pagination = obj.pagination;
        this.filters = obj.filters;
        this.$forceUpdate();
      }
      this.getContractsList();
    },
    getPeriod(value){
      const period = statement_period.find((item) => item.value === value);
      return period ? period.label : "N/A";
    },
    getNextDate(value){
      let dateToFormat;
      const today = moment();

      switch (value) {
        case '1':
          dateToFormat = today.endOf('month');
          break;
        case '2':
          if (today.month() < 6) {
            dateToFormat = today.month(5).date(30);
          } else {
            dateToFormat = today.month(11).date(31);
          }
          break;
          case '3':
          if (today.month() < 3){
            dateToFormat = today.month(2).date(31);
          } else if (today.month() < 6){
            dateToFormat = today.month(5).date(30);
          } else if (today.month() < 9){
            dateToFormat = today.month(8).date(30);
          } else {
            dateToFormat = today.month(11).date(31);
          }
          break;
          case '4':
          dateToFormat = today.month(11).date(31);
          break;
        default:
          return "N/A";
      }
      return dateToFormat.format('DD-MM-YYYY');
    },
    checkForDuplicates(array) {
      const uniqueValues = new Set();

      for (const item of array) {
        const firstElement = item[0];
        if (uniqueValues.has(firstElement)) {
          return true;
        }
        uniqueValues.add(firstElement);
      }

      return false;
    },
    async SaveSubLicenseDocument(id, files) {
      try {
        const payload = {
          contract_id: id,
          upload: files,
        };
        if (
          payload.upload !== null &&
          payload.upload.length > 0
        ) {
          // console.log(payload.upload, "document value");
          const hasDuplicates = this.checkForDuplicates(
            payload.upload
          );
          if (hasDuplicates) {
            alert(
              "Duplicate files detected. Please remove duplicates before saving."
            );
            return;
          }
          const newFilesString = JSON.stringify(
            payload.upload
          );
          // console.log(
          //   this.uploadedFilesPrev,
          //   "previous uploaded files before upload"
          // );
          const prevFilesString = JSON.stringify(this.uploadedFilesPrev);
          if (newFilesString !== prevFilesString) {
            this.uploadedFilesPrev = [...payload.upload];
            const response = await ContractServices.saveSubLicenseService(payload);
            // console.log("Document saved successfully:", response.data);
          } else {
            alert(
              "The uploaded files are the same as the previously saved files. Please upload different files."
            );
          }
        } else {
          alert("Upload some files to save.");
        }
      } catch (error) {
        console.error("Error saving document:", error);
      }
    },
    async removeFile(contract_id, file) {
      try{
        const payload = {
          contract_id: contract_id,
          upload: file,
        }
        const response = await ContractServices.saveSubLicenseService(payload);
        // console.log("File removed successfully:", response.data);
      } catch(error){
        console.error("Error removing file:", error);
      }
    },
    uploadModalFile(files) {
      this.modalData = {
        ...this.modalData,
        upload : files
      };
      // console.log("Modal Data: ", this.modalData);
    },
    async changeLastStatementDue(contract_id, value){
      try {
        const payload = {
          contract_id: contract_id,
          lastStatementDue: value,
        };
        const response = await ContractServices.saveLastStatementDue(payload);

      } catch(error) {
        console.error("Error saving last statement due:", error);
      }
    },
    changeModalAmountAdd(value){
      this.modalData = {
        ...this.modalData,
        amountAdded : value
      }
    },
    async saveHistory(id) {
      try{
        let object = {
          upload: this.modalItem.upload,
          amountAdded: this.modalItem.lastStatementDue,
          date: this.modalItem.lastStatementReceivedDate
        }
        let payload = {
          contract_id: id,
          history: object,
        }
        const response = await ContractServices.saveItemInHistory(payload);
      } catch(error) {
        console.error("Error saving history:", error);
      }
    },
    async saveModalData(id) {
      const loader = this.$loading.show();
      try {
        console.log(this.modalData, "<<<")
        if(this.modalData.date) {
          // console.log("Modal Data: ", this.modalData);
          this.showModal = false;
          await this.saveHistory(id);
          if(this.modalData.amountAdded){
            await this.changeLastStatementDue(id, this.modalData.amountAdded);
          }
          if(this.modalData.upload.length > 0){
            await this.SaveSubLicenseDocument(id, this.modalData.upload);
          }
          await this.changeLastStatementDueDate(id, this.modalData.date);
          this.modalData = {};
          // console.log("Modal Data: ", this.modalData);
          this.onChange()
        }else {
          alert("Date not added, Add date to save");
        }
      } finally{
        loader.hide();
      }
    },
    onSearchMovie(searchMovieTerm) {
      return;
      this.searchMovieTerm = searchMovieTerm;
      this.$store.dispatch("master/setMoviesMaster", {
        search: searchMovieTerm,
      });
    },
    onSearchCustomer(searchCustomerTerm) {
      return;
      this.searchCustomerTerm = searchCustomerTerm;
      this.$store.dispatch("master/setVendorsMaster", {
        search: searchCustomerTerm,
      });
    },
    getImgSrc(file) {
      if (Array.isArray(file)) {
        if (file[1]) {
          return this.files_url + file[1];
        }
      } else {
        return this.files_url + file;
      }
    },
    openFile(file) {
      if (Array.isArray(file)) {
        if (file[1]) {
          window.open(this.files_url + file[1], "__blank");
        }
      } else {
        window.open(this.files_url + file, "__blank");
      }
    },
    checkIfImage(file) {
      if (!file) return false;

      let uploadPath = "";
      if (Array.isArray(file)) {
        uploadPath = file[1];
      } else {
        uploadPath = file;
      }

      if (
        typeof uploadPath === "string" &&
        uploadPath.match(/\.(png|jpg|jpeg|webp)$/)
      ) {
        return true;
      }
      return false;
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY');
    },
  },
  mounted() {
    this.loadContractList();

    this.$store.dispatch("master/setVendorsMaster");
    this.$store.dispatch("master/setMoviesMaster");

    this.$store.dispatch("master/setLabelMaster", { key: labels.language });

    // Tree Data
    this.$store.dispatch("master/setLabelTreeMaster", {
      key: labels.rights_tree,
      master: labels.rights,
      sub_master: labels.sub_right,
    });
    this.$store.dispatch("master/setLabelTreeMaster", {
      key: labels.territory_tree,
      master: labels.territory,
      sub_master: labels.sub_territory,
    });
  },
  beforeMount() {
  }
};
</script>

<style>
.history-box {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  max-height: 250px;
  overflow-y: auto;
}

.history-item-row {
  display: flex; /* Use flexbox for horizontal alignment */
  align-items: flex-start; /* Align items to the top of the row */
  border-bottom: 1px dashed #ccc;
  padding-bottom: 5px;
  margin-bottom: 5px;
}

.history-index {
  flex-shrink: 0; /* Prevents the number column from shrinking */
  width: 40px; /* Adjust this width to control the column size */
  font-weight: bold;
}

.history-content {
  flex-grow: 1; /* Allows the content to fill the remaining space */
}
</style>

